<template>
    <div class="cont" v-if="myLessons">
        <div v-for="lessonG in myLessons" :key="lessonG.$id">
            <Til>{{lessonG.ClassName}}</Til>
            <div class="list">
                <ClassItem class="list-item" :disable="item.IsLocked" v-for="item in lessonG.Lessons" :key="item.Id" @ck="goClass(item)">{{item.Name}}</ClassItem>
            </div>
        </div>
    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
import ClassItem from '@/components/ClassItem'
export default {
    name: 'MyClassTil',
    mixins: [mainDelegate],
    components: {
        ClassItem
    },
    methods: {
        goClass(item) {
            this.$router.push({ name: 'myclasslist', params: { id: item.Id } })
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
.list {
    padding: 8px 16px;
}
@media only screen and (min-width: @rwd) {
    .list {
        padding: 0px;
        display: flex;
        flex-wrap: wrap;
        .list-item {
            width: 270px;
            margin-right: 20px;
            &:last-child {
                margin-right: 0px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/MyClassTil.vue